// SecurityAndPrivacy.tsx
import React, { useState } from "react";
import * as AlfredoStyles from "../../../../styles/components/configuration/sections/accountSection/SecurityAndPrivacy";

interface SecurityAndPrivacyProps {
  isEditing: boolean;
  formData: any;
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => void;
  handleSave: (objectType: any) => void;
  updateState: (newState: any) => void;
}

const SecurityAndPrivacy: React.FC<SecurityAndPrivacyProps> = ({
  isEditing,
  formData,
  handleInputChange,
  handleSave,
  updateState,
}) => {
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handlePasswordChange = (field: string, value: string) => {
    setPasswordData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handlePasswordSave = () => {
    // Aqui você implementaria a lógica de alteração de senha
    console.log("Alterando senha:", passwordData);

    // Simulando sucesso
    handleSave("security");
    setShowPasswordFields(false);
    setPasswordData({
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    });

    updateState({
      message: "Senha alterada com sucesso!",
      messageType: "success",
    });
  };

  const handleTwoFactorChange = (enabled: boolean) => {
    handleInputChange(
      { target: { value: enabled } } as any,
      "twoFactorEnabled"
    );
    handleSave("security");
  };

  return (
    <AlfredoStyles.FieldsContainer>
      {/* Alteração de Senha */}
      <AlfredoStyles.SectionTitle
        style={{ fontSize: "var(--fs-xl)", marginTop: "var(--sp-16)", marginBottom: "var(--sp-20)" }}
      >
        Segurança da Conta
      </AlfredoStyles.SectionTitle>

      {!showPasswordFields ? (
        <div
          style={{
            padding: "var(--sp-20)",
            backgroundColor: "#f8f9fa",
            borderRadius: "12px",
            marginBottom: "var(--sp-24)",
            border: "1px solid #e1e5e9",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "var(--sp-16)",
            }}
          >
            <div style={{ flex: 1, minWidth: "calc(var(--u) * 200)" }}>
              <div
                style={{
                  fontWeight: 600,
                  marginBottom: "var(--sp-8)",
                  fontSize: "var(--fs-base)",
                }}
              >
                Senha da Conta
              </div>
              <div style={{ color: "#6c757d", fontSize: "var(--fs-md)" }}>
                Última alteração: 3 meses atrás
              </div>
            </div>
            <AlfredoStyles.Button
              onClick={() => setShowPasswordFields(true)}
              style={{ padding: "var(--sp-10) var(--sp-20)", fontSize: "var(--fs-md)" }}
            >
              Alterar Senha
            </AlfredoStyles.Button>
          </div>
        </div>
      ) : (
        <div
          style={{
            padding: "var(--sp-24)",
            backgroundColor: "#f8f9fa",
            borderRadius: "12px",
            marginBottom: "var(--sp-24)",
            border: "1px solid #e1e5e9",
          }}
        >
          <div style={{ marginBottom: "var(--sp-20)" }}>
            <div
              style={{ fontWeight: 600, fontSize: "var(--fs-base)", marginBottom: "var(--sp-8)" }}
            >
              Alterar Senha
            </div>
            <div style={{ color: "#6c757d", fontSize: "var(--fs-md)" }}>
              Digite sua senha atual e a nova senha
            </div>
          </div>

          <AlfredoStyles.InputWrapper>
            <label>Senha Atual</label>
            <AlfredoStyles.Input
              type="password"
              value={passwordData.currentPassword}
              onChange={(e) =>
                handlePasswordChange("currentPassword", e.target.value)
              }
              placeholder="Digite sua senha atual"
            />
          </AlfredoStyles.InputWrapper>

          <AlfredoStyles.InputWrapper>
            <label>Nova Senha</label>
            <AlfredoStyles.Input
              type="password"
              value={passwordData.newPassword}
              onChange={(e) =>
                handlePasswordChange("newPassword", e.target.value)
              }
              placeholder="Digite a nova senha"
            />
          </AlfredoStyles.InputWrapper>

          <AlfredoStyles.InputWrapper>
            <label>Confirmar Nova Senha</label>
            <AlfredoStyles.Input
              type="password"
              value={passwordData.confirmPassword}
              onChange={(e) =>
                handlePasswordChange("confirmPassword", e.target.value)
              }
              placeholder="Confirme a nova senha"
            />
          </AlfredoStyles.InputWrapper>

          <div
            style={{
              display: "flex",
              gap: "var(--sp-12)",
              marginTop: "var(--sp-20)",
              flexWrap: "wrap",
            }}
          >
            <AlfredoStyles.Button
              onClick={handlePasswordSave}
              disabled={
                !passwordData.currentPassword ||
                !passwordData.newPassword ||
                passwordData.newPassword !== passwordData.confirmPassword
              }
            >
              <AlfredoStyles.MaterialIcons>lock</AlfredoStyles.MaterialIcons>
              Salvar Nova Senha
            </AlfredoStyles.Button>
            <AlfredoStyles.SecondaryButton
              onClick={() => {
                setShowPasswordFields(false);
                setPasswordData({
                  currentPassword: "",
                  newPassword: "",
                  confirmPassword: "",
                });
              }}
            >
              Cancelar
            </AlfredoStyles.SecondaryButton>
          </div>
        </div>
      )}

      {/* Autenticação de Dois Fatores - Sempre editável */}
      <AlfredoStyles.SectionTitle
        style={{ fontSize: "var(--fs-xl)", marginTop: "var(--sp-32)", marginBottom: "var(--sp-20)" }}
      >
        Autenticação de Dois Fatores
      </AlfredoStyles.SectionTitle>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "var(--sp-20)",
          backgroundColor: "#f8f9fa",
          borderRadius: "12px",
          marginBottom: "var(--sp-24)",
          border: "1px solid #e1e5e9",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#f1f3f4";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#f8f9fa";
        }}
      >
        <div style={{ flex: 1 }}>
          <div
            style={{ fontWeight: 600, marginBottom: "var(--sp-8)", fontSize: "var(--fs-base)" }}
          >
            Verificação em Duas Etapas
          </div>
          <div style={{ color: "#6c757d", fontSize: "var(--fs-md)" }}>
            Aumente a segurança da sua conta com autenticação adicional
          </div>
        </div>
        <label
          style={{
            position: "relative",
            display: "inline-block",
            width: "calc(var(--u) * 52)",
            height: "calc(var(--u) * 28)",
            marginLeft: "var(--sp-16)",
          }}
        >
          <input
            type="checkbox"
            checked={formData.twoFactorEnabled || false}
            onChange={(e) => handleTwoFactorChange(e.target.checked)}
            style={{ opacity: 0, width: 0, height: 0 }}
          />
          <span
            style={{
              position: "absolute",
              cursor: "pointer",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: formData.twoFactorEnabled ? "#0066cc" : "#ccc",
              transition: "0.4s",
              borderRadius: "28px",
            }}
          >
            <span
              style={{
                position: "absolute",
                height: "calc(var(--u) * 22)",
                width: "calc(var(--u) * 22)",
                left: formData.twoFactorEnabled ? "calc(var(--u) * 24)" : "calc(var(--u) * 3)",
                bottom: "calc(var(--u) * 3)",
                backgroundColor: "white",
                transition: "0.4s",
                borderRadius: "50%",
                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
              }}
            />
          </span>
        </label>
      </div>

      {/* Sessões Ativas */}
      <AlfredoStyles.SectionTitle
        style={{ fontSize: "var(--fs-xl)", marginTop: "var(--sp-32)", marginBottom: "var(--sp-20)" }}
      >
        Sessões Ativas
      </AlfredoStyles.SectionTitle>

      <div
        style={{
          padding: "var(--sp-20)",
          backgroundColor: "#f8f9fa",
          borderRadius: "12px",
          marginBottom: "var(--sp-16)",
          border: "1px solid #e1e5e9",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "var(--sp-16)",
          }}
        >
          <div style={{ flex: 1, minWidth: "calc(var(--u) * 200)" }}>
            <div
              style={{ fontWeight: 600, marginBottom: "var(--sp-8)", fontSize: "var(--fs-base)" }}
            >
              Chrome • Windows
            </div>
            <div style={{ color: "#6c757d", fontSize: "var(--fs-md)" }}>
              São Paulo, Brasil • Ativo agora
            </div>
          </div>
          <AlfredoStyles.SecondaryButton
            style={{ fontSize: "var(--fs-md)", padding: "var(--sp-8) var(--sp-16)" }}
          >
            Encerrar Sessão
          </AlfredoStyles.SecondaryButton>
        </div>
      </div>

      <div
        style={{
          backgroundColor: "#fff3cd",
          border: "1px solid #ffeaa7",
          borderRadius: "8px",
          padding: "var(--sp-12) var(--sp-16)",
          marginTop: "var(--sp-24)",
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", gap: "var(--sp-12)" }}>
          <div style={{ fontSize: "var(--fs-base)", flexShrink: 0 }}>🔒</div>
          <div style={{ fontSize: "var(--fs-md)", color: "#856404" }}>
            <strong>Dica de segurança:</strong> Recomendamos ativar a
            verificação em duas etapas e usar senhas fortes para proteger sua
            conta.
          </div>
        </div>
      </div>
    </AlfredoStyles.FieldsContainer>
  );
};

export default SecurityAndPrivacy;
